import React, { useEffect, useMemo, useState } from "react";
import Swal from "sweetalert2";
import {
  ButtonNavigation,
  ContainerBanner,
  ContainerCountdown,
  ContainerDetail,
  ContainerNavigation,
  ContainerPaymentDetail,
  ContainerPaymentProof,
  CopyText,
  ImageBadge,
  Pillbox,
  Typography,
} from "./FormPayment.styled";

import { func } from "../../../utils";
import _function, { formatRupiah } from "../../../utils/function";
import useWindowSize from "../../../hooks/useWindowSize";
import { useNavigate, useParams } from "react-router-dom";
import { useUserData } from "../../../store/user";
import { usePageContextFunction } from "../../../context/PageContext";
import {
  useFetchEventDetail,
  useGetPaymentDetails,
  usePostProofPayment,
} from "../../../networks";
import { BannerFormRegistration } from "../FormRegistration/components/Banner";
import { CountdownTimer } from "../../../components";
import { ReactComponent as RequiredIcon } from "../FormRegistration/assets/required-form.svg";
import { FileUploadFormRegistration } from "../FormRegistration/components/FileUpload";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;
const imgBankPath = `${process.env.REACT_APP_API_HOST}/uploads/bank/`;

const FormPayment = () => {
  const { size } = useWindowSize();
  const navigate = useNavigate();
  const { accessToken, registrationData } = useUserData();
  const schoolCategory = String(
    registrationData?.school_category
  )?.toLowerCase();
  const { setIdInView } = usePageContextFunction();
  const [imageBuktiPayment, setImageBuktiPayment] = useState("");
  const { mutateAsync: postProofPayment } = usePostProofPayment();

  const isSmallScreen = (size?.height || 0) <= 667;
  const isExtraSmallScreen =
    (size?.width || 0) <= 375 && (size?.height || 0) <= 600;
  const isMobileView = (size?.width || 0) <= 830;
  const isDisabledButton = !imageBuktiPayment;

  const isBrowserSupportCopy = navigator.clipboard ? true : false;

  const { city, category, region_id, mode } = useParams();
  const { data: dataDetailRaw, isFetching: fetchingDetailRaw } =
    useFetchEventDetail(
      registrationData?.region_name?.toLowerCase().replace(/[^a-z]/g, "")
    );
  const eventCategoryId = registrationData?.event_category_id;
  const dataDetail = dataDetailRaw?.data?.data?.eventDetail;

  const { data: dataPaymentDetail, isFetching: fetchingDetailPayment } =
    useGetPaymentDetails({ regionId: registrationData?.region_id });
  // useGetPaymentDetails(17, "SMA");

  const totalFee =
    eventCategoryId === 3
      ? dataPaymentDetail?.data?.data?.dance_fee
      : dataPaymentDetail?.data?.data?.[schoolCategory + "_fee"];

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text.toString());
      console.log("copied!");
      console.log(text);
    } catch (err) {
      console.log("Failed to copy!");
    }
  };

  const NOW_IN_MS = new Date(
    dataPaymentDetail?.data?.data?.expired_at?.toString()
  ).getTime();
  const launchDateCountdown = NOW_IN_MS;

  const handleSelectFile = (file) => {
    setImageBuktiPayment(file);
  };

  useEffect(() => {
    setIdInView("slick-scroll");
    if (!accessToken) navigate("/");
  }, [accessToken]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (imageBuktiPayment) {
      let formData = new FormData();
      formData.append("payment_photo", imageBuktiPayment);
      try {
        const postData = await postProofPayment({
          registrationId: registrationData?.id,
          formData,
        });

        if (!!postData) {
          navigate("/pembayaran-success");
        }
      } catch (error) {
        console.log("ini error");
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Coba ulangi kembali!",
        });
        setImageBuktiPayment("");
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
      setImageBuktiPayment("");
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          maxWidth: "600px",
          margin: "0 auto",
          backgroundColor: "#FFF",
        }}
      >
        <ContainerBanner
          img={func.getStaticImg("/bg/swosh-abstrac-paymentform.svg")}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              <Typography fontWeight="800">{dataDetail?.city}</Typography>
              <Typography
                color="#6A7481"
                fontSize="13px"
                fontWeight="800"
                lineHeight="20px"
              >
                {dataDetail?.event_date}
              </Typography>
              <div style={{ display: "flex" }}>
                <img src={func.getStaticImg("/illustration/pin-blue.svg")} />
                <Typography color="#6A7481" fontSize="12px" lineHeight="16px">
                  {dataDetail?.location}
                </Typography>
              </div>
            </div>
            <ImageBadge
              src={
                imgPath +
                (isMobileView
                  ? dataDetail?.key_visual_mobile
                  : dataDetail?.key_visual)
              }
            />
          </div>
        </ContainerBanner>
        <form enctype="multipart/form-data">
          <ContainerDetail>
            <Typography fontSize="12px" lineHeight="16px">
              Pendaftaran Piala by.U
              <Pillbox
                bgColor={
                  eventCategoryId === 3
                    ? "#F48120"
                    : registrationData?.school_category === "SMA"
                    ? "#00BCF1"
                    : "#77B341"
                }
              >
                {eventCategoryId === 3
                  ? "Dance Competition"
                  : `Futsal - ${registrationData?.school_category}`}
              </Pillbox>
            </Typography>
            <Typography fontWeight="800" style={{ margin: "4px 0 4px 0" }}>
              Pembayaran
            </Typography>
            <Typography
              color="#6A7481"
              fontSize="12px"
              lineHeight="16px"
              style={{ marginBottom: "20px" }}
            >
              Lakukan transfer ke rekening di bawah ini dan segera upload bukti
              pembayaranmu untuk konfirmasi
            </Typography>
            <ContainerPaymentDetail
              img={func.getStaticImg("/bg/bg-card-home-detail.png")}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <Typography color="#000" fontSize="13px" lineHeight="20px">
                    Nomor Rekening
                  </Typography>
                  <Typography
                    className="flex gap-x-1"
                    color="#000"
                    fontSize="14px"
                    fontWeight="800"
                    lineHeight="19px"
                  >
                    {dataPaymentDetail?.data?.data?.account_number
                      .toString()
                      .replace(/(\d{4})(?=\d)/g, "$1 ")}{" "}
                    {isBrowserSupportCopy && (
                      <CopyText
                        className="flex gap-x-2"
                        onClick={() =>
                          copyToClipboard(
                            dataPaymentDetail?.data?.data?.account_number
                          )
                        }
                      >
                        <img src={func.getStaticImg("/icon/sa-copy.svg")} />{" "}
                        <u>Salin</u>
                      </CopyText>
                    )}
                  </Typography>
                </div>
                <img
                  src={imgBankPath + dataPaymentDetail?.data?.data?.bank_logo}
                  style={{
                    width: 32,
                    height: 32,
                    alignSelf: "center",
                    objectFit: "contain",
                  }}
                />
              </div>
              <div>
                <Typography color="#000" fontSize="13px" lineHeight="20px">
                  Nama Rekening Tujuan
                </Typography>
                <Typography
                  color="#000"
                  fontSize="14px"
                  fontWeight="800"
                  lineHeight="19px"
                >
                  {dataPaymentDetail?.data?.data?.account_number_name}
                </Typography>
              </div>
              <div>
                <Typography color="#000" fontSize="13px" lineHeight="20px">
                  Total Tagihan
                </Typography>
                <Typography
                  className="flex gap-x-1"
                  color="#000"
                  fontSize="14px"
                  fontWeight="800"
                  lineHeight="19px"
                >
                  {formatRupiah(totalFee)}
                  {isBrowserSupportCopy && (
                    <CopyText
                      className="flex gap-x-2"
                      onClick={() =>
                        copyToClipboard(dataPaymentDetail?.data?.data?.bill)
                      }
                    >
                      <img src={func.getStaticImg("/icon/sa-copy.svg")} />{" "}
                      <u>Salin</u>
                    </CopyText>
                  )}
                </Typography>
              </div>
            </ContainerPaymentDetail>
            <ContainerCountdown>
              <Typography
                color="#6A7481"
                fontSize="12px"
                fontWeight="800"
                lineHeight="16px"
              >
                Batas Waktu Pembayaran
              </Typography>
              <div>
                <CountdownTimer
                  targetDate={launchDateCountdown}
                  isTextInsideBox
                />
              </div>
            </ContainerCountdown>
            <ContainerPaymentProof>
              <FileUploadFormRegistration
                cn="flex flex-col gap-y-[8px]"
                label="Upload Bukti Pembayaran"
                value={imageBuktiPayment}
                isRequired
                description="Upload foto bukti pembayaran"
                errorMessage={""}
                onChange={handleSelectFile}
              />
            </ContainerPaymentProof>
          </ContainerDetail>
          <ContainerNavigation>
            <ButtonNavigation
              onClick={() => navigate("/")}
              color="#1F2D3D"
              bgColor="#FFF"
            >
              Kembali
            </ButtonNavigation>
            <ButtonNavigation
              disabled={isDisabledButton}
              onClick={handleSubmit}
              color="#FFF"
              bgColor={isDisabledButton ? "#B8C1CB" : "#00BCF1"}
              cursor={isDisabledButton ? "not-allowed" : "pointer"}
            >
              Lanjut
            </ButtonNavigation>
          </ContainerNavigation>
        </form>
      </div>
    </>
  );
};

export default FormPayment;
